import React from "react";
import { Link } from "react-router-dom";
import EmbedWordpress from "../components/EmbedWordpress";
import Thumbnail from "../components/Thumbnail";
import {
    BASE_10,
} from "../constants";
import IProduct from "../interfaces/IProduct";
import IProductGroup from "../interfaces/IProductGroup";
import IProductPlayType from "../interfaces/IProductPlayType";

interface IProps {
    displayItemsType?: "product" | "productplaytype";
    productGroup: IProductGroup;
    productPlayTypes: IProductPlayType[];
    products: IProduct[];
}

export default class ProductGroupPage extends React.Component<IProps> {
    public render(): JSX.Element {
        const {
            displayItemsType,
        } = this.props;

        if (displayItemsType === "productplaytype") {
            return this.renderProductPlayTypes();
        }
        return this.renderProducts();
    }

    protected renderProductPlayTypes(): JSX.Element {
        const {
            productGroup,
            productPlayTypes,
        } = this.props;

        const abbrev = productGroup.abbrev.replace(/ /g, "-");

        const sortedProductPlayTypes = productPlayTypes.sort((a: IProductPlayType, b: IProductPlayType): number => {
            return parseInt(a.id, BASE_10) - parseInt(b.id, BASE_10);
        });

        return (
            <div className="content-wrapper product-play-types-list">
                <EmbedWordpress slug={ `above-productgroup-${ abbrev }` } />
                <div className="columns is-multiline">
                    { sortedProductPlayTypes.map((ppt: IProductPlayType): JSX.Element => {
                        return (
                            <div className="is-one-quarter column" key={ ppt.id }>
                                <Link
                                    to={ `/${ productGroup.abbrev }/${ ppt.abbrev }/` }
                                >
                                    <Thumbnail entity={ ppt } />
                                </Link>
                            </div>
                        );
                    }) }
                </div>
                <EmbedWordpress slug={ `below-productgroup-${ abbrev }` } />
            </div>
        );
    }

    protected renderProducts(): JSX.Element {
        const {
            productGroup,
            products,
            productPlayTypes,
        } = this.props;

        const abbrev = productGroup.abbrev.replace(/ /g, "-");

        return (
            <div className="content-wrapper products-list">
                <EmbedWordpress slug={ `above-productgroup-${ abbrev }` } />
                <div className="columns">
                    { products.map((product: IProduct): JSX.Element => {
                        const filteredPlayTypes = productPlayTypes.filter((ppt: IProductPlayType): boolean => {
                            return ppt.productId === product.id;
                        });

                        filteredPlayTypes.sort((a: IProductPlayType, b: IProductPlayType): number => {
                            return parseInt(a.id, BASE_10) - parseInt(b.id, BASE_10);
                        });

                        return (
                            <div className="column is-one-quarter" key={ product.id }>
                                <Thumbnail entity={ product } />
                                <ul>
                                    { filteredPlayTypes.map((ppt: IProductPlayType): JSX.Element => {
                                        return (
                                            <li key={ ppt.id }>
                                                <Link
                                                    to={ `/${ productGroup.abbrev }/${ ppt.abbrev }/` }
                                                >{ ppt.name }</Link>
                                            </li>
                                        );
                                    }) }
                                </ul>
                            </div>
                        );
                    }) }
                </div>
                <EmbedWordpress slug={ `below-productgroup-${ abbrev }` } />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/ProductGroupPage.tsx